<script setup lang="ts">
import {ExtendedUser} from "@/types";
import BaseLayout from "@/layouts/BaseLayout.vue";
import ProfileLayout from "@/Pages/settings/layouts/ProfileLayout.vue";
import {Head, useForm} from "@inertiajs/vue3";
import TextField from "@/components/forms/TextField.vue";
import TextArea from "@/components/forms/TextArea.vue";

interface Props {
    user: ExtendedUser,
}

const props = defineProps<Props>()
defineOptions({
    layout: BaseLayout
})

const form = useForm({
    name: '',
    public_key: ''
})

const submit = () => {
    form.post(route('settings.ssh_keys.store'))
}
</script>

<template>
    <Head title="Add SSH key" />
    <profile-layout
        :user="props.user"
    >
        <h1 class="font-weight-medium text-h5 mt-5">
            Add new SSH Key
        </h1>
        <v-divider class="my-5" />
        <v-form @submit.prevent="submit">
            <v-row :dense="true">
                <v-col
                    cols="12"
                    md="6"
                    class="pa-0"
                >
                    <text-field
                        v-model="form.name"
                        label="Title"
                        type="text"
                    />
                </v-col>
            </v-row>
            <v-row :dense="true">
                <v-col
                    cols="12"
                    class="pa-0"
                >
                    <text-area
                        v-model="form.public_key"
                        label="Key"
                        type="text"
                        placeholder="Begins with 'ssh-rsa', 'ecdsa-sha2-nistp256', 'ecdsa-sha2-nistp384', 'ecdsa-sha2-nistp521', 'ssh-ed25519'"
                    />
                </v-col>
            </v-row>
            <success-btn
                type="submit"
                rounded="lg"
            >
                Add SSH key
            </success-btn>
        </v-form>
    </profile-layout>
</template>

<style scoped>

</style>
